import { TypographyWithEllipsis } from '@modules/common/components/TypographyWithEllipsis';
import { Stack } from '@mui/material';
import { AnalysisViewFragment } from 'generated/graphql';

interface DashboardAnalysisTitleProps {
  analysis: AnalysisViewFragment;
}

export const DashboardAnalysisTitle = ({
  analysis,
}: DashboardAnalysisTitleProps) => {
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <TypographyWithEllipsis
        color="text.primary"
        variant="subtitle1"
        className="dashboard-analysis-title"
      >
        {analysis.title}
      </TypographyWithEllipsis>
    </Stack>
  );
};
